export default __webpack_public_path__ + "static/media/Trash.8f1eabd5.svg";